(function () {
  'use strict';

  function rootPath() {
    return (
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
    ) || '/';
  }

  function hydrateJudge(scope) {
    (scope || document)
      .querySelectorAll('[data-foxena-v2-card]')
      .forEach(function (card) {

        var source =
          card.querySelector(
            '[data-foxena-v2-judge-source]'
          );

        var pill =
          card.querySelector(
            '[data-foxena-v2-rating]'
          );

        if (!source || !pill) {
          return;
        }

        var badge =
          source.querySelector(
            '.jdgm-prev-badge'
          );

        if (!badge) {
          pill.hidden = true;
          return;
        }

        var rating =
          parseFloat(
            badge.getAttribute(
              'data-average-rating'
            )
          );

        var count =
          parseInt(
            badge.getAttribute(
              'data-number-of-reviews'
            ),
            10
          );

        if (
          !count ||
          count <= 0 ||
          Number.isNaN(rating)
        ) {
          pill.hidden = true;
          return;
        }

        var ratingEl =
          pill.querySelector(
            '[data-foxena-v2-rating-value]'
          );

        var countEl =
          pill.querySelector(
            '[data-foxena-v2-rating-count]'
          );

        if (ratingEl) {
          ratingEl.textContent =
            rating.toFixed(1);
        }

        if (countEl) {
          countEl.textContent =
            count;
        }

        pill.hidden = false;
      });
  }

  function setButtonState(button, next) {
    var text =
      button.querySelector(
        '[data-foxena-v2-add-text]'
      );

    if (!text) {
      return;
    }

    button.classList.remove(
      'is-loading',
      'is-added',
      'is-ripple'
    );

    button.removeAttribute(
      'aria-busy'
    );

    if (next === 'loading') {
      button.classList.add(
        'is-loading',
        'is-ripple'
      );

      button.setAttribute(
        'aria-busy',
        'true'
      );

      text.textContent =
        'Adding...';

    } else if (next === 'added') {

      button.classList.add(
        'is-added'
      );

      text.textContent =
        '✓ Added';

    } else if (next === 'error') {

      text.textContent =
        'Try Again';

    } else {

      text.textContent =
        'Add to Cart';
    }
  }

  async function addProduct(button) {
    var id =
      button.dataset.variantId;

    if (
      !id ||
      button.classList.contains(
        'is-loading'
      )
    ) {
      return;
    }

    setButtonState(
      button,
      'loading'
    );

    try {
      var response =
        await fetch(
          rootPath() +
          'cart/add.js',
          {
            method: 'POST',

            credentials:
              'same-origin',

            headers: {
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            body:
              JSON.stringify({
                items: [
                  {
                    id:
                      Number(id),

                    quantity:
                      1
                  }
                ]
              })
          }
        );

      if (!response.ok) {
        throw new Error(
          'Cart add failed'
        );
      }

      var payload =
        await response.json();

      setButtonState(
        button,
        'added'
      );

      document.dispatchEvent(
        new CustomEvent(
          'cart:updated',
          {
            bubbles:
              true,

            detail: {
              source:
                'foxena-v2-card',

              response:
                payload
            }
          }
        )
      );

      document.dispatchEvent(
        new CustomEvent(
          'cart:update',
          {
            bubbles:
              true,

            detail: {
              source:
                'foxena-v2-card'
            }
          }
        )
      );

      setTimeout(
        function () {
          setButtonState(
            button,
            'idle'
          );
        },
        1400
      );

    } catch (error) {

      console.error(
        '[FOXENA V2] cart error',
        error
      );

      setButtonState(
        button,
        'error'
      );

      setTimeout(
        function () {
          setButtonState(
            button,
            'idle'
          );
        },
        1500
      );
    }
  }

  /*
   * Only intercept clicks on the actual
   * Add to Cart button.
   *
   * Product image/title links remain untouched.
   */
  document.addEventListener(
    'click',
    function (event) {

      var button =
        event.target.closest(
          '[data-foxena-v2-add]'
        );

      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      addProduct(
        button
      );
    }
  );

  function init(scope) {
    hydrateJudge(
      scope || document
    );

    (scope || document)
      .querySelectorAll(
        '.foxena-v2-card .fwc-heart-btn, .foxena-v2-card .foxena-heart-btn'
      )
      .forEach(function (element) {
        element.remove();
      });
  }

  /*
   * Initial page load
   */
  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      }
    );

  } else {

    init(document);
  }

  /*
   * Shopify Theme Editor:
   * initialize only the section that
   * Shopify has just reloaded.
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      init(
        event.target
      );
    }
  );

  /*
   * IMPORTANT:
   *
   * The old global MutationObserver has
   * intentionally been removed.
   *
   * It was observing the entire document
   * subtree and repeatedly calling
   * init(document) whenever DOM content
   * changed.
   *
   * This is unnecessary for normal
   * storefront navigation and can create
   * excessive work on mobile browsers.
   */

})();